import React, { useMemo, useState } from 'react';
import SettingsSidebar from './SettingsSidebar';
import { SETTINGS_CATEGORIES, DEFAULT_SETTINGS_ITEM } from './settingsCategories';

const SettingsSidebarPanel = ({ panelProps }) => {
  const [activeItem, setActiveItem] = useState(
    panelProps?.params?.activeItem || DEFAULT_SETTINGS_ITEM
  );
  const categories = useMemo(() => SETTINGS_CATEGORIES, []);

  const handleSelect = (itemId) => {
    setActiveItem(itemId);

    const bodaproContext = window['bodapro-context'];
    if (!bodaproContext?.addPanel) {
      return;
    }

    switch (itemId) {
      case 'profile':
        bodaproContext.addPanel({
          id: 'settings-profile-panel',
          title: 'Account Profile',
          componentName: 'settingsPanel',
          groupId: 'main-panel',
          params: {
            initialActiveItem: itemId,
          },
          replacePanel: true,
        });
        break;
      default:
        break;
    }
  };

  return (
    <SettingsSidebar
      categories={categories}
      activeItem={activeItem}
      onSelect={handleSelect}
    />
  );
};

export default React.memo(SettingsSidebarPanel);

